var _CalculadoraModel_valor, _CalculadoraModel_acumulador, _CalculadoraModel_limparTela, _CalculadoraModel_operacao;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
// Constantes para deixar mais descritivo;
const NAO_LIMPAR_TELA = false;
const LIMPAR_TELA = true;
export default class CalculadoraModel {
    // Construtor inicializa os valores;
    constructor(valor = null, acumulador = null, operacao = null, limparTela = false) {
        // # na frente significa que é privado;
        _CalculadoraModel_valor.set(this, void 0);
        _CalculadoraModel_acumulador.set(this, void 0);
        _CalculadoraModel_limparTela.set(this, void 0);
        _CalculadoraModel_operacao.set(this, void 0);
        __classPrivateFieldSet(this, _CalculadoraModel_valor, valor, "f");
        __classPrivateFieldSet(this, _CalculadoraModel_acumulador, acumulador, "f");
        __classPrivateFieldSet(this, _CalculadoraModel_operacao, operacao, "f");
        __classPrivateFieldSet(this, _CalculadoraModel_limparTela, limparTela, "f");
    }
    // Retorna o valor substituindo ponto por vírgula;
    get valor() {
        var _a;
        return ((_a = __classPrivateFieldGet(this, _CalculadoraModel_valor, "f")) === null || _a === void 0 ? void 0 : _a.replace('.', ',')) || '0';
    }
    // Função que pega o número digitado e concatena com o valor já presente;
    numeroDigitado(novoValor) {
        return new CalculadoraModel(__classPrivateFieldGet(this, _CalculadoraModel_limparTela, "f") || !__classPrivateFieldGet(this, _CalculadoraModel_valor, "f") ? novoValor : __classPrivateFieldGet(this, _CalculadoraModel_valor, "f") + novoValor, __classPrivateFieldGet(this, _CalculadoraModel_acumulador, "f"), __classPrivateFieldGet(this, _CalculadoraModel_operacao, "f"), NAO_LIMPAR_TELA);
    }
    // Função que verifica se já existe um ponto no valor, se não, ela adiciona um;
    pontoDigitado() {
        var _a;
        return new CalculadoraModel(((_a = __classPrivateFieldGet(this, _CalculadoraModel_valor, "f")) === null || _a === void 0 ? void 0 : _a.includes('.')) ? __classPrivateFieldGet(this, _CalculadoraModel_valor, "f") : __classPrivateFieldGet(this, _CalculadoraModel_valor, "f") + '.', __classPrivateFieldGet(this, _CalculadoraModel_acumulador, "f"), __classPrivateFieldGet(this, _CalculadoraModel_operacao, "f"), NAO_LIMPAR_TELA);
    }
    // Retorna uma nova instância vazia da calculadora;
    limpar() {
        return new CalculadoraModel();
    }
    // Função que pega a operação digitada e chama a função de calcular;
    operacaoDigitada(proximaOperacao) {
        return this.calcular(proximaOperacao);
    }
    // Função que realiza o calculo, ou não, dependendo da operação anterior digitada;
    calcular(proximaOperacao = null) {
        const acumulador = !__classPrivateFieldGet(this, _CalculadoraModel_operacao, "f")
            ? parseFloat(__classPrivateFieldGet(this, _CalculadoraModel_valor, "f"))
            : eval(`${__classPrivateFieldGet(this, _CalculadoraModel_acumulador, "f")} ${__classPrivateFieldGet(this, _CalculadoraModel_operacao, "f")} ${__classPrivateFieldGet(this, _CalculadoraModel_valor, "f")}`);
        const valor = !__classPrivateFieldGet(this, _CalculadoraModel_operacao, "f") ? __classPrivateFieldGet(this, _CalculadoraModel_valor, "f") : `${acumulador}`;
        return new CalculadoraModel(valor, acumulador, proximaOperacao, proximaOperacao ? LIMPAR_TELA : NAO_LIMPAR_TELA);
    }
}
_CalculadoraModel_valor = new WeakMap(), _CalculadoraModel_acumulador = new WeakMap(), _CalculadoraModel_limparTela = new WeakMap(), _CalculadoraModel_operacao = new WeakMap();
